import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import SearchBox from "src/features/transcripts/SearchBox";
import TranscriptsContainer from "src/features/transcripts/TranscriptsContainer";
const TranscriptsTab = () => {
    return (_jsxs(_Fragment, { children: [_jsx(SearchBox, {}), _jsx(TranscriptsContainer, {})] }));
};
export default TranscriptsTab;
